export const RESERVATION_BARE_MINIMUM_EXTENT = {
    origin: true,
};
export const RESERVATION_ORDER_ITEMS_EXTENT = {
    orderItems: true,
    products: true,
    ...RESERVATION_BARE_MINIMUM_EXTENT,
};
export const RESERVATION_DATA_EXTENT = {
    reservationGroups: true,
    generalNotes: true,
    channelManagerNotes: true,
    specialRequestNotes: true,
    accounts: true,
    companionships: true,
    businessSegments: true,
    availabilityBlocks: true,
    rates: true,
    partnerCompanies: true,
    vouchers: true,
    travelAgencies: true,
    ...RESERVATION_BARE_MINIMUM_EXTENT,
};
export const RESERVATION_FULL_DETAIL_EXTENT = {
    ...RESERVATION_ORDER_ITEMS_EXTENT,
    ...RESERVATION_DATA_EXTENT,
};

export const UPSELL_HOUR_AVAILABILITY = 14 * 24;
